
import React, {FC} from 'react';

import * as styles from './styles.module.scss';

type WelcomeProps = {
	children: string
}

export const Welcome: FC<WelcomeProps> = ({children}) => (
	<div className={styles.welcome}>
		<div>
			Welcome, {children}!
		</div>
		<div className={styles.heading}>
			Your Account
		</div>
	</div>
);

export const Explore = () => (
	<div className={styles.heading}>
		Explore BodySpec
	</div>
);
